import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IPagination } from '@interfaces/common.interface';

@Component({
  selector: 'app-list-footer',
  templateUrl: 'list-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListFooterComponent {
  @Output() loadRecords: EventEmitter<IPagination> = new EventEmitter();
  @Output() changeListSize: EventEmitter<number> = new EventEmitter();

  @Input() pageSize = 10;
  @Input() totalItems = 0;
  @Input() disabled = false;

  windowWidth = document.body.clientWidth;
  currentPage = 1;

  @Input() set page(pageNumber: number) {
    this.currentPage = pageNumber + 1;
  }

  emitChangeListSize(event: number): void {
    this.pageSize = event;
    if (this.currentPage * event <= this.totalItems) {
      this.changeListSize.emit(event);
    }
  }

  emitPageChange(page: number): void {
    this.loadRecords.emit({ page: page - 1, itemsPerPage: this.pageSize });
  }
}
